module.exports = __webpack_public_path__ + "static/media/twicebakedcheesesouffle.4946e7b4.png";